module.exports = __webpack_public_path__ + "static/media/davide_groppi.f9b948cf.svg";